module.exports = __webpack_public_path__ + "img/39.23952e2d.jpg";